import React from 'react';
import vocoContext from '../contexts/VocoContext'

export default class Message extends React.Component {
    static contextType = vocoContext
    
    constructor(props, context) {
        super(props, context)
        
        this.state = {
            message: this.context.message,
            buttons : []
        }
    }
    
    componentDidMount() { 
        let ioc = this.context.ioc     
        ioc.run("3r/message-api/helpers/getMessageButtons", this.context.message)
            .then(buttons => this.setState({buttons : buttons}))
    }
    
    setOutput(){
        let context = this.context
        let ioc = context.ioc
        let locale = context.modules.locale
        let override = this.context?.config?.override || {}
        let navigation = context.navigation
        let message = context.message || {}
        let buttons = this.state.buttons
        
        let embedContent = ioc.injectWithModules(["3r/message-api/content/embedMessageContent"], function(embedMessageContent, text){
            return embedMessageContent(message, {}, text)     
        }) 
        
        
        let title = locale.copy(override.title) || embedContent(message.title)
        let titleElement = (typeof override.titleDisplay == "undefined" ) ? "h3" : override.titleDisplay
        let markedUp = locale.copy(override.message) || ioc.run("3r/message-api/content/embedMessageContent", message)
        let image = locale.copy(override.image) || ( (message.offerImage && message.offerImage != "undefined.jpg") ? message.offerImage : "" )
        
        let modules = context.modules
        let device = context.device
        
        const press = ioc.injectWithModules(["3r/message-api/helpers/press"], function(press, buttonIndex) {
            let button = buttons[buttonIndex]
            
            /* In order for container tactics to react to button clicks they
             * must be triggered as CHI outcomes. This must happen at the 
             * 'close' time hence if not closing trigger a non-final outcome.
             */
            
            if (!button.close) {
                device.triggerOutcome(button.value, false) 
            }
            
            return press(
                null,
                function () {
                    /* This is the 'close' function invoked by press to close
                     * the message, if the current tactic is a sub-tactic in a
                     * container then it must trigger a final outcome for the
                     * container to react to.
                     */
                    
                    if (modules.parent) {
                        device.triggerOutcome(button.value, true) 
                    } else {
                        return navigation.next()
                    }
                },
                message,
                button
            ) 
        })

        return (
            <div className={["wf-tactic-minimalSimpleMessage", "wf-tactic", "container", "minimalSimpleMessage"].join(" ")} id={"minimalSimpleMessage" + message.systemId}>
                <div className = "text-center">
                    {titleElement ? React.createElement(titleElement, { class: 'wf-tactic-minimalSimpleMessage-title wf-tactic-title wf-title' }, title) : "" }
                </div>
                {(image)
                    ?  <div className="wf-tactic-minimalSimpleMessage-offerImageBox wf-tactic-offerImageBox wf-offerImageBox text-center imgDiv">
                            <img className="wf-tactic-minimalSimpleMessage-offerImage wf-tactic-offerImage wf-offerImage smImage" width="80%"  src={image} alt={title}/>
                        </div>
                    : ""
                }
                {(markedUp)
                    ?   <p className="wf-tactic-minimalSimpleMessage-message wf-tactic-message wf-message text-center" dangerouslySetInnerHTML={{__html: markedUp}}></p> 
                    : ""
                }
            
                <div className="wf-tactic-minimalSimpleMessage-actions wf-tactic-actions wf-actions text-center" key="buttons">
                    {buttons && typeof buttons.map == "function" ? buttons.map((button, i) => 
                        button.type == 'hyperlink' ? 
                            <a className={"wf-tactic-minimalSimpleMessage-action-" + i + "-hyperlink wf-tactic-minimalSimpleMessage-hyperlink wf-tactic-hyperlink wf-hyperlink"} href={button.hyperlink.url} rel="" target={button.hyperlink.target}>
                              <button type="button" className={"wf-tactic-minimalSimpleMessage-action-" + i + " wf-tactic-minimalSimpleMessage-action wf-tactic-action wf-action btn btn-primary"} style={{margin: "10px"}} onClick={press.bind(null,i)} key={button.value}>
                                {embedContent(button.caption)}
                              </button>
                            </a>
                        :   <button className={"wf-tactic-minimalSimpleMessage-action-" + i + " wf-tactic-minimalSimpleMessage-action wf-tactic-action wf-action btn btn-primary"} style={{margin : "10px"}} onClick={press.bind(null,i)} key={button.value}>
                                {embedContent(button.caption)}
                            </button>
                    ) : undefined }
                </div>
            </div>
        )
    }
    
    render(){
        return (
            <div>
                {this.setOutput()}
            </div>
        );
    };
};
    
